/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Nda_Signsuccess2Inputs */

const en_coinvestments_nda_signsuccess2 = /** @type {(inputs: Coinvestments_Nda_Signsuccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NDA agreement confirmed successfully`)
};

/**
* | output |
* | --- |
* | "NDA agreement confirmed successfully" |
*
* @param {Coinvestments_Nda_Signsuccess2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_nda_signsuccess2 = /** @type {((inputs?: Coinvestments_Nda_Signsuccess2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Nda_Signsuccess2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_nda_signsuccess2(inputs)
});
export { coinvestments_nda_signsuccess2 as "coInvestments_nda_signSuccess" }